<template>
  <section id="hero">
    <!--
    {{Hero.vue}}
      :src="require('@/assets/home-hero.jpg')"
    -->
    <span id="sectionTopHeroClimate"><small></small></span>
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/images/climate/LightningTreeCropped_25.jpg')"
      class="white--text"
      gradient="65deg, rgba(5, 11, 31, .9) , rgba(5, 11, 31, .6) 50%, rgba(5, 11, 31, .1)"
    >
      <v-container class="fill-height px-4 pt-12 pb-9">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading title="CLIMATE ACTIVISTS" />

          <base-body>
            <span class="para">
                <em>To solve an emergency like the climate crisis, we need to collectively and immediately exit “normal mode” and abandon the gradual policy advocacies . . . We need to realize . . . that we are in clear and imminent danger, and that we must immediately mobilize with everything we’ve got.</em><br>
                —Margaret Klein Salamon, <em>Facing the Climate Emergency</em>
            </span>
            <br><br>
            <span class="para">
            The climate crisis is scary. We want to show you that responding to it can also be exciting. Because the solutions it calls for are big. In order to implement them in Truro, we’ll have to come together like we never have before. We’ll have to all get behind a common project — that of building a truly green Truro economy, infrastructure, and way of life. We think both building and living that life will be far more exciting, meaningful and fulfilling than what we have today. Read on to see why we must do it, why it will be so good, and how you can help. We call this story Doom and Bloom!
            </span>
          </base-body>

        <div id='scrollToNav'>
        <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('ImmediateSteps')"
        >
            Immediate Steps
        </v-btn>
        <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('Doom')"
        >
            DOOM
        </v-btn>
        <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('Bloom')"
        >
            BLOOM
        </v-btn>
        <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('TenSteps')"
        >
            TEN STEPS
        </v-btn>
        <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('Misconceptions')"
        >
            Misconceptions
        </v-btn>
        </div>

          <!--
          <div
            :class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
            class="d-flex flex-wrap"
          >
            <base-btn>
              Discover More
            </base-btn>

            <span class="font-weight-bold ml-6 mr-4 my-4">or</span>

            <base-btn
              :ripple="false"
              class="pa-1"
              height="auto"
              text
            >
              Get Started Now
            </base-btn>
          </div>
              class="xs='12'"
              md="6"
              offset-md="6"
            <v-card>
            </v-card>

          -->
          <!--

          <v-row>
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              New Projects:
              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="wpClick"
              >
                Water Protectors<span class="hidden-lg-and-down">...</span>
              </v-btn>
            </v-col>
          </v-row>
          -->

          <!--
          <v-row>
            <v-col
              class="xs='12'"
              sm="9"
              offset-sm="3"
            >
              New Studies:
              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="wellsClick"
              >
                Private Wells and Truro Safe Water<span class="hidden-lg-and-down">...</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="xs='12'"
              sm="9"
              offset-sm="3"
            >
              New Studies:

              <v-btn
                small
                class="ml-2 mr-0 small"
                @click="wellsClick"
              >
                Private Wells and Truro Safe Water<span class="hidden-lg-and-down">...</span>
              </v-btn>

              <a
                href="https://docstruro.org"
                target="_blank"
              >
                Docs Truro</a> <small>(url)</small>
            </v-col>
          </v-row>
          -->
        <!--
            @click="wellsClick"
        -->
        <!--

          <v-row>
            <v-col
              class="xs='12'"
              sm="11"
              offset-sm="1"
            >
              New Studies:
              <a
                href="https://docstruro.org"
                target="_blank"
              >
                <v-btn
                  small
                  class="ml-2 mr-0 small red"
                >
                  Private Wells and Truro Safe Water<span class="hidden-lg-and-down">...</span>
                </v-btn>

               </a> <small> from <em>Docs for Truro Safe Water</em></small>
            </v-col>
          </v-row>
        -->
          <span class="trace">Hero.vue</span>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    data: () => ({

      target: '#sectionTop',
      duration: 1000,
      offset: 100,
      easing: 'easeInOutCubic',
    }),

    provide: {
      theme: { isDark: true },
    },

    computed: {
      minHeight () {
        const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

        return `calc(${height} - ${this.$vuetify.application.top}px)`
      },
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },

    },

    methods: {

      handleClick: function (where) {
        // alert("target="+this.target+" options="+this.options)
        this.$vuetify.goTo(this.target + where, this.options)
        // alert(this.options)
        console.log('SCROLLING TO ', this.target, where)
        // this.$vuetify.goTo(-100, this.options)
      },

      wpClick: function (event) {
        this.$router.push({ name: 'splashWQ' })
      },
      wellsClick: function (event) {
        this.$router.push({ name: 'wells' })
      },

    },
  }
</script>

<style scoped>
  .para {
    font-size: 110%;
    color: white;
  }
</style>
